import { CCA2 } from "./cca2";
import { CCA3 } from "./cca3";
import { MemberRole, UserType } from "./enum";
export interface LabelValueType<T> {
  label: string;
  value: T;
}
export interface CountryCCA3 extends LabelValueType<CCA3> {
  cca2: CCA2;
}

export enum MILLISECONDS {
  SECOND = 1000,
  MINUTE = SECOND * 60,
  HOUR = MINUTE * 60,
  DAY = HOUR * 24,
  WEEK = DAY * 7,
  MONTH = DAY * 30,
  YEAR = DAY * 365
}

export type CanAccess = (type: UserType, role?: MemberRole) => boolean;
